/** The key for AWIN tracking, used around various places. e.g. the incoming URLs have this key as the query string
 * parameter key, our internal tracking for utms/attribution uses it as the key into that record.
 */
export const AWIN_TRACKING_KEY = 'awc';
export const AWIN_MERCHANT_ID = '130687';

const subscriptionTypesToPayCommission = ['PREMIUM', 'LITE'];

/** Returns the commission group for AWIN, if we should be paying commission, otherwise returns undefined. */
export function getAwinCommissionGroup(
  drawTypePlanCode: string,
  drawDays: 'Tuesday' | 'Friday' | 'Both',
) {
  if (subscriptionTypesToPayCommission.includes(drawTypePlanCode)) {
    return `${drawTypePlanCode}_${drawDays === 'Both' ? 'TWO_DRAWS' : 'ONE_DRAW'}`;
  }
  return undefined;
}
